// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"757":"b80845c7","915":"32980e15"}[chunkId] + ".chunk.css";
};